<!-- eslint-disable vue/no-v-html -->
<template>
    <cs-card>
        <template #header>
            <div class="cs-card__icon">
                <mdi-icon icon="mdiImageText" />
            </div>

            <div class="cs-card__title">
                Description
            </div>

            <div class="grow"></div>

            <div
                class="cs-card__icon-r"
                title="Edit Description"
                @click="editDescription"
            >
                <mdi-icon icon="mdiPencil" />
            </div>
        </template>

        <div
            v-if="englishDescription"
            class="text-sm"
            v-html="englishDescription"
        >
        </div>

        <div v-else class="cs-card__no-content">
            There is no English description for this article.
        </div>
    </cs-card>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import CsCard from '@/components/CsCard.vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore();
const router = useRouter();

const article = computed(() => store.state.articles.cArticle);
/** @type {import("vue").ComputedRef<string>} */
const englishDescription = computed(() => article.value.short_description ?? '');

/**
 * Initialize the component.
 * This is run by a watcher ever time the article ID changes.
 *
 * @async
 * @returns {Promise<void>}
 */
async function init()
{
}

function editDescription()
{
    const article_id = article.value.id;
    router.push({
        name:   'edit-article-description',
        params: { article_id },
    });
}

watch(article, init, { immediate: true });
</script>
